<template>
  <div style="margin:10px">
    <v-form direction="horizontal" :model="jsaddForm" :rules="jsaddRules" ref="jsaddRuleForm">
      <!-- <v-form-item label="销方名称" :label-col="labelCol" :wrapper-col="wrapperCol">
        <span>{{jsaddForm.xfmc}}</span>
      </v-form-item> -->
      <v-form-item
        label="角色名称"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        prop="js_mc"
        has-feedback
      >
        <v-input v-model.trim="jsaddForm.js_mc" placeholder="角色名称"></v-input>
      </v-form-item>
      <v-form-item label="描述" :label-col="labelCol" :wrapper-col="wrapperCol">
        <v-input type="textarea" v-model="jsaddForm.js_ms" placeholder="描述"></v-input>
      </v-form-item>
      <v-form-item
        label="启用"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-switch v-model="jsaddForm.xy_bz"></v-switch>
      </v-form-item>
    </v-form>
    <div style="text-align:center">
      <v-button type="success" icon="save" @click="save('jsaddRuleForm')">保存</v-button>
      <v-button type="error" icon="close-circle-o" @click="cancel">取消</v-button>
    </div>
  </div>
</template>

<script>
let jsaddForm = {
  js_mc: "",
  js_ms: "",
  xy_bz:true
  // xfid: ""
};
let old_rolename = "";
export default {
  data() {
    // let checkrolename = (rule, value, callback) => {
    //   let self = this;
    //   if (self.jsaddForm.rolename) {
    //     callback(new Error("请输入角色名称!"));
    //   } 
    // };
    return {
      jsaddRules: {
        js_mc: [
          {
            required: true,
            message: "请输入角色名称!"
          }
          // ,
          // {
          //   trigger: "blur",
          //   validator: checkrolename
          // }
        ]
      },
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 14
      },
      jsaddForm,
      old_rolename
    };
  },
  created() {
    //alert(this.$route.query.id)
    if (this.$route.query.id) {
      this.jsaddForm.id = this.$route.query.id;
      this.init();
    }
  },
  methods: {
    init: function() {
      this.$axios.get("api/system/qxgl/get-js-first/" + jsaddForm.id).then(res => {
        let self = this;
         
        if(res.data.data.xy_bz == "1"){
          res.data.data.xy_bz = true
        }
        self.jsaddForm = res.data.data;
        self.old_rolename = self.jsaddForm.rolename;
      });
    },
    save: function(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios.post("api/system/qxgl/set-js-first", this.jsaddForm).then(res => {
            if (res.data.code == 200) {
              this.$message["success"](res.data.message);
              xadmin.close();
            } else {
              this.$message["error"](res.data.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancel: function() {
      xadmin.close();
      xadmin.father_reload();
    }
  }
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/qxgl/jswhadd.vue